export const groupedLegendPlugin = {
  id: 'groupedLegendPlugin',
  defaults: {
    groupBy: (ds) => ds.label
  },

  beforeInit(chart, _args, opts) {
    // -- Sécurise les branches d’options
    chart.options.plugins ||= {}
    const userPluginOpts = chart.options.plugins.groupedLegendPlugin

    // Normalise: si l’utilisateur met un booléen, null, ou une fonction par erreur
    const normalized =
      userPluginOpts &&
      typeof userPluginOpts === 'object' &&
      !Array.isArray(userPluginOpts)
        ? userPluginOpts
        : {}

    const groupBy =
      (typeof opts?.groupBy === 'function' && opts.groupBy) ||
      (typeof normalized.groupBy === 'function' && normalized.groupBy) ||
      ((ds) => ds.label)

    chart.options.plugins.legend ||= {}
    const legend = chart.options.plugins.legend

    // labels doit être un objet
    if (
      !legend.labels ||
      typeof legend.labels !== 'object' ||
      Array.isArray(legend.labels)
    ) {
      legend.labels = {}
    }

    const pick = (v) => (Array.isArray(v) ? v[0] : v)
    const colorOf = (c, i, key) => pick((c.data.datasets[i] || {})[key])

    // Remplace generateLabels par une version groupée
    legend.labels.generateLabels = (c) => {
      const groups = {}
      c.data.datasets.forEach((ds, idx) => {
        let key
        try {
          key = groupBy(ds, idx, c)
        } catch {
          key = ds.label ?? `Groupe ${idx}`
        }
        key = typeof key === 'string' ? key : String(key)
        ;(groups[key] ||= []).push(idx)
      })

      return Object.entries(groups).map(([text, indices]) => {
        const first = indices[0]
        const hiddenAll = indices.every((i) => c.isDatasetVisible(i) === false)
        return {
          text,
          fillStyle: colorOf(c, first, 'backgroundColor'),
          strokeStyle: colorOf(c, first, 'borderColor'),
          lineWidth: c.data.datasets[first]?.borderWidth ?? 1,
          hidden: hiddenAll,
          indices // champ custom
        }
      })
    }

    // onClick groupé
    const origOnClick =
      typeof legend.onClick === 'function' ? legend.onClick : null
    legend.onClick = (e, item, leg) => {
      const c = leg.chart
      const indices = Array.isArray(item.indices)
        ? item.indices
        : item.datasetIndex != null
          ? [item.datasetIndex]
          : []
      if (!indices.length) return

      // toggle groupé
      const shouldShow = indices.some((i) => !c.isDatasetVisible(i))
      indices.forEach((i) => c.setDatasetVisibility(i, shouldShow))
      c.update()

      if (origOnClick) {
        try {
          origOnClick(e, item, leg)
        } catch {}
      }
    }
  }
}
